import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import './index.css';
import App from './App';
import { ClientProvider } from './ClientContext'; // Import the ClientProvider
import { ToastProvider } from './contexts/ToastContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

const onRedirectCallback = (appState) => {
  const targetPath = appState?.returnTo || window.location.pathname || '/';
  window.history.replaceState({}, document.title, targetPath);
};

root.render(
  <Auth0Provider
    domain={process.env.REACT_APP_AUTH0_DOMAIN}
    clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
    onRedirectCallback={onRedirectCallback}
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    }}
  >
    <React.StrictMode>
      <ToastProvider>
        <ClientProvider>
          <App />
        </ClientProvider>
      </ToastProvider>
    </React.StrictMode>
  </Auth0Provider>,
);
